import { H4 } from '@snsw/react-component-library';
import { PlantDesignDetailsPage } from 'plantDesign/constants/plantDesignDetailsPage';
import { getWasDesignedBeforeLabel } from 'plantDesign/pages/plantDesignDetails/components/DesignAlterationDetails';
import React from 'react';
import { capitalizeFirstLetter } from 'shared/utils/Helpers';
import styles from '../PlantDesignReview.module.scss';

export const RegistrationTypeReview = (props) => {
  const { data = {} } = props;

  const COMMON_CONSTANTS = PlantDesignDetailsPage.common;
  const ALTERATION_CONSTANTS = PlantDesignDetailsPage.designAlteration;
  const alteration = data.alterationDetails;

  const labelPropertyMap = alteration && [
    {
      title: COMMON_CONSTANTS.registrationTypeLabel,
      val: data['registrationType'],
      key: 'registrationType',
    },
    {
      title: getWasDesignedBeforeLabel(data['plantType'], data['subType']),
      val: alteration['wasDesignedBefore'],
      key: 'wasDesignedBefore',
    },
    {
      title: ALTERATION_CONSTANTS.reasonForAlteration.label,
      val: alteration['reasonForAlteration'],
      key: 'reasonForAlteration',
    },
    {
      title: ALTERATION_CONSTANTS.registrationNumber.label,
      val: alteration['registrationNumber'],
      key: 'registrationNumber',
    },
    {
      title: ALTERATION_CONSTANTS.registeredLocation.label,
      val: alteration['registeredLocation'],
      key: 'registeredLocation',
    },
  ];

  const renderCommonDetails = () => {
    let details = labelPropertyMap.reduce((result, element) => {
      if (element.val) {
        result.push(
          <div key={element.key}>
            <div className={styles.summaryLabel}>{element.title}</div>
            <div className={styles.summaryValue}>{capitalizeFirstLetter(element.val)}</div>
          </div>,
        );
      }
      return result;
    }, []);

    return details;
  };

  return (
    <>
      {data && alteration && (
        <>
          <H4>Registration type</H4>
          {renderCommonDetails()}
        </>
      )}
    </>
  );
};
